import { addGlobalUncaughtErrorHandler } from 'qiankun'

// sessionStorage 在隐私模式等场景可能被禁用，存取需兜底
const storage = {
  get(k) { try { return sessionStorage.getItem(k) || '' } catch (e) { return '' } },
  set(k, v) { try { sessionStorage.setItem(k, v) } catch (e) {} },
  del(k) { try { sessionStorage.removeItem(k) } catch (e) {} },
}

// 子应用 entry 里的 import() 失败只会产生静默的 unhandledrejection，
// qiankun 生命周期（beforeLoad/beforeMount 等）感知不到；记一条全局日志，
// 现场排查时控制台有迹可循（恢复动作由 armLoadWatchdog 负责）
export function bindQiankunGlobalErrorLog() {
  if (window.qiankunGlobalErrorBound) return
  window.qiankunGlobalErrorBound = true
  addGlobalUncaughtErrorHandler(e => {
    console.error('[qiankun] 页面未捕获异常（内容区空白时优先怀疑子应用资源加载失败）:', (e && (e.reason || e.error || e.message)) || e)
  })
}

// afterMount 生命周期打点：子应用真正完成 mount 的时间戳。
// 不能用"容器是否有子节点"判断加载成败——qiankun 在 entry 拉取后、子应用
// mount 前（loader.js 的 render 'loading'）就会把包装 div 塞进容器，
// import() 失败导致 bootstrap 挂起时容器是非空的
export function markQiankunMounted() {
  window.__qiankunLastMountAt = Date.now()
}

// 子应用加载偶发失败（发版窗口旧 hash 资源 404、网络抖动）时页面会永远停在空白，
// 刷新才能恢复。看门狗超时检查武装之后是否出现 afterMount 打点（entry 404 /
// chunk 404 / bootstrap 挂起等一切静默失败都不会有打点）：没有则本会话自动整页
// 刷新一次，再失败弹确认框交由用户手动重试；标记存 sessionStorage 防止持续故障
// 时无限刷新，加载成功后清除标记，后续偶发失败仍可自愈
export function armLoadWatchdog(vm, opts = {}) {
  const routePrefix = opts.routePrefix || '/unifiedContentLibrary'
  const appName = opts.appName || '统一内容库'
  const delay = opts.delay || 12000
  const retryKey = 'load_retried:' + routePrefix
  // 1s 容差：吸收页面组件 mounted 与 qiankun afterMount 之间的微任务时序抖动
  const armedAt = Date.now()

  clearTimeout(vm._loadWatchdogTimer)
  vm._loadWatchdogTimer = setTimeout(() => {
    if (!vm.$route || vm.$route.path.indexOf(routePrefix) !== 0) return
    if ((window.__qiankunLastMountAt || 0) >= armedAt - 1000) {
      storage.del(retryKey)
      return
    }
    if (storage.get(retryKey) !== '1') {
      storage.set(retryKey, '1')
      window.location.reload()
      return
    }
    vm.$confirm(appName + '加载失败，是否重新加载？').then(ok => {
      if (ok) window.location.reload()
    })
  }, delay)
}
